import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Ban, ShieldCheck } from "lucide-react";

/** Silently suspend / restore a login. `kind` = "customer" (portal) or "user" (staff). */
export function AccessToggleButton({ kind, id, name, suspended, onChanged, compact = false }) {
    const [busy, setBusy] = useState(false);
    const url = kind === "customer" ? `/customers/${id}/portal-access` : `/users/${id}/access`;
    const what = kind === "customer" ? "portal access" : "login access";

    const toggle = async () => {
        const next = !suspended;
        if (next && !window.confirm(`Suspend ${what} for ${name}? They won't be notified, and nothing is deleted.`)) return;
        setBusy(true);
        try {
            await api.post(url, { suspended: next });
            toast.success(next ? `${what[0].toUpperCase()}${what.slice(1)} suspended` : `${what[0].toUpperCase()}${what.slice(1)} restored`);
            onChanged?.(next);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Update failed");
        } finally { setBusy(false); }
    };

    const Icon = suspended ? ShieldCheck : Ban;
    const label = suspended ? (kind === "customer" ? "Restore portal" : "Restore") : (kind === "customer" ? "Suspend portal" : "Suspend");
    return (
        <Button size="sm" variant={compact ? "ghost" : "outline"} onClick={toggle} disabled={busy}
                title={suspended ? `Restore ${what}` : `Suspend ${what} (silent)`}
                className={suspended ? "" : "text-amber-700 dark:text-amber-400"}
                data-testid={`${kind}-access-toggle-${id}`}>
            <Icon className={compact ? "w-3.5 h-3.5" : "w-4 h-4 mr-1"} />
            {!compact && label}
        </Button>
    );
}
